import React, { useState, useRef } from 'react';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import api from '~/services/api';
import history from '~/services/history';
import Select from '~/components/Form/Select';
// Importando componente
import Card from '~/components/Card';
import Input from '~/components/Form/Input';
import Button from '~/components/Form/Button';

import { Container } from './styles';

export default function IncorporadoraNew() {
  const inputRef = useRef(null);
  const [carregar, setCarregar] = useState(false);
  const [produtoUnico, setProdutoUnico] = useState(false);

  const options = [
    {
      label: 'Não',
      value: false
    },
    {
      label: 'Sim',
      value: true
    }
  ]

  async function handlerSubmit(data) {
    try {
      setCarregar(true);
      inputRef.current.setErrors({});
      const schema = Yup.object().shape({
        name: Yup.string().required('Preencha o campo nome'),
        unique_product: Yup.string().required('Selecione uma opção')

      });
      await schema.validate(data, {
        abortEarly: false,
      });

      await api.post('/incorporadora', {
        name: data.name,
        unique_product: data.unique_product
      });

      toast.success('Incorporadora cadastrada com sucesso');
      history.push('/incorporadora');
    } catch (err) {
      setCarregar(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        inputRef.current.setErrors(validationErrors);
      } else {
        toast.error('Incorporadora já foi cadastrada.');
      }
    } finally {
      setCarregar(false);
    }
  }

  return (
    <Container>
      <h4>Cadastrar Incorporadora</h4>
      <Card>
        <Form ref={inputRef} onSubmit={handlerSubmit} autoComplete="off">
          <Input icon="MdBusiness" label="Nome" name="name" type="text" />
          <Select 
            name="unique_product"
            labelSelect="Produto único ?"
            options={options} 
            onChange={(e) => setProdutoUnico(e.value)}
          />
          <Button tamanho="40px" load={carregar}>
            Cadastrar
          </Button>
        </Form>
      </Card>
    </Container>
  );
}
